import { createStore } from 'vuex'
import  { auth } from "@/store/AuthModule";
import { paciente } from '@/store/PacienteModule';
import { user } from '@/store/UserModule';
import { personal } from './PersonalModule';
import { diagnost } from './DiagnostModule';
import { cita } from './CitaModule';
import { citaTemp } from './CitaTempModule';
import { role } from './RoleModule';
import { permission } from './PermissionModule';
import { poblacion } from './PoblacionModule';
import { profesion } from './ProfesionModule';
import { globalVar } from './GlobalModule';
import { pacientetemp } from './PacienteTempModule';
import { fPago } from './FPagosModule';
import { tipoEsp } from './TipoespModule';
import { tipoRef } from './TiporefModule';
import { cirugia } from './CirugiaModule';
import { cliente } from './ClienteModule';

export default createStore({
  modules: {
    auth:auth,
    paciente:paciente,
    user:user,
    personal:personal,
    diagnost:diagnost,
    cita:cita,
    role:role,
    permission:permission,
    poblacion:poblacion,
    profesion:profesion,
    globalVar:globalVar,
    pacientetemp:pacientetemp,
    citaTemp:citaTemp,
    fPago:fPago,
    tipoEsp:tipoEsp,
    tipoRef:tipoRef,
    cirugia:cirugia,
    cliente:cliente,
  }
})

